/**
 * HOME_FAQ — homepage FAQ copy, shared between the visible <FAQSection /> and the
 * FAQPage JSON-LD on the Landing page. Keeping one source means the rendered
 * answers and the structured data AI engines lift never drift apart.
 *
 * The first three entries are written "prompt-first" to target the exact
 * generative-search prompts where LinkLane currently under-indexes:
 *   - "Which URL shortener offers robust analytics?"
 *   - "Top link management platforms with UTM tracking?"
 *   - "How to create trackable QR codes?"
 * Each answer leads with a direct, citable claim so ChatGPT/Perplexity/Gemini
 * can quote a single self-contained passage.
 */
export const HOME_FAQ = [
  {
    q: "Which link shortener has AI built in?",
    a: 'LinkLane is an AI-native link platform — and its AI does more than explain. It reads your real click data and explains performance in plain English with anomalies and a 30-day forecast ("Analytics Intelligence"), gives you a dashboard briefing of what changed and what to do next, and then acts: it applies fixes in one click (turn on conversion tracking, tag traffic, seed a routing rule — with undo), sends proactive alerts before you ask (expiring links, near a click cap, winners with no tracking), and an AI strategist turns a goal into a grounded plan you can apply in one batch. It also turns a sentence into a fully-built link or bio page. AI is included on every paid plan, metered with monthly AI credits, grounded on your actual numbers — never invented.',
  },
  {
    q: "How does LinkLane's AI work and what does it cost?",
    a: "Each paid plan includes a monthly pool of AI credits — Pro 200, Growth 750, Enterprise 3,000 — plus rollover and top-ups. Lightweight actions like alias or tag suggestions cost 1 credit, link explanations and intent cost 2, the weekly digest 3, and bio-page generation 5. Enterprise can bring its own AI key for unmetered use. AI is not available on the Free plan.",
  },
  {
    q: "Which URL shortener has the best analytics?",
    a: "LinkLane offers real-time analytics on every short link — unique vs. total clicks, geo, device, browser, and referrer breakdowns, a weekday-by-hour click heatmap, a live click feed, and one-click CSV export. Campaigns roll multiple links into a single dashboard, and analytics are included on the free plan with no credit card required.",
  },
  // {
  //   q: "Does LinkLane support UTM tracking for campaigns?",
  //   a: "Yes. LinkLane builds and appends UTM parameters (source, medium, campaign, term, and content) to any link, groups links into campaigns with roll-up analytics, and reports source/medium performance — so you can track UTM-tagged links across email, social, and paid ads from one place.",
  // },
  {
    q: "How do I create a trackable QR code?",
    a: "Every LinkLane short link includes a branded QR code you can download as PNG or SVG and customize with your own colors and logo. Scans are tracked in real time as clicks, with geo, device, and time-of-scan analytics. To create one, shorten a link and open its QR tab — it's free.",
  },
  // {
  //   q: "Can I add a call-to-action or banner to my links?",
  //   a: "Yes. LinkLane's CTA overlays show a branded banner — your headline, message, and an optional call-to-action button — before a visitor reaches the destination, then forward them on (manually or after a short countdown). It never frames the destination, so it works on every site. CTA overlays are a Growth+ feature and fire your retargeting pixels on the same page.",
  // },
  {
    q: "Is LinkLane just a link shortener?",
    a: "No — shortening is the entry point. LinkLane is an AI-native platform: link-in-bio pages, smart routing, real-time analytics that AI explains for you, branded QR, campaigns, a developer API, and team workspaces all live in one place.",
  },
  {
    q: "Is there a free plan?",
    a: "Yes. Free gives you 50 links and 1,000 tracked clicks a month, custom aliases, QR codes, and basic analytics with no credit card required. AI features start on the Pro plan.",
  },
  {
    q: "What can I build with bio pages?",
    a: "A full link-in-bio page with your avatar and branding, drag-to-reorder links, and 12 themes (free through enterprise) — all previewed live on a mobile mockup as you edit.",
  },
  // {
  //   q: "What is smart routing?",
  //   a: "One short link that sends different visitors to different destinations — by geography, device, A/B variant, time-of-day, round-robin rotation, or per-visitor rules. Ideal for launches, regional campaigns, and app installs.",
  // },
  // {
  //   q: "Can I use my own domain and the API?",
  //   a: "The REST API, API keys, custom domains, webhooks, and Slack/Discord integrations are all available from Pro (1 custom domain on Pro, 5 on Growth, unlimited on Enterprise). SSO/SAML, SCIM provisioning, team seats, and white-label are Enterprise.",
  // },
  // {
  //   q: "Can I export my data?",
  //   a: "Yes. Every link's analytics export to CSV — timestamp, device, browser, country, referrer, and source included.",
  // },
];

export default HOME_FAQ;
